import { useContext } from "react";
import s from "./style.module.css";
import { useNavigate } from "../../../../node_modules/react-router-dom/dist/index";
import { ActivatedNameContext } from "../../contexts/ActivatedNameContext";

export function Logo() {
  const { setActivatedName } = useContext(ActivatedNameContext);
  const navigate = useNavigate();
  const navigateToHome = () => {
    setActivatedName("Accueil");
    navigate("/accueil");
  };
  return (
    <div onClick={navigateToHome} className={s.container}>
      <img src="assets/logo.webp" alt="logo DevHop" className={s.logo} />
      <div className={s.box}>
        <h1 className={s.title}>DevHop</h1>
        <h2 className={s.subTitle}>BY CHARLY</h2>
      </div>
    </div>
  );
}
